import { Guid } from 'Lib/Guid';
import { map } from 'rxjs/operators';
import webApi from '../../../Lib/WebApi';
import { callApi, camelizeObjectKeys } from '../../Helpers/rxjsHelpers';
import {
  AvailableMddsUpdateQuery,
  CreateAssignedValueTestRequest,
  GetSourceEntitiesRequest,
  MaximumDryDensityTestResponse,
  SelectedTestResultsQuery,
} from './types';

/**
 * API Call to retrieve the queried MDD tests
 */
export const callApiGetAvailableMddTests = (query: AvailableMddsUpdateQuery) => {
  return callApi(webApi.soil.assignedMddTests.getQueriedForWorksheets.get(query.params)).pipe(
    map((response) => {
      return {
        Worksheets: response.Body['MaximumDryDensityTests'].map((w: any) => camelizeObjectKeys(w)),
        Messages: response.Body['Messages'],
      } as MaximumDryDensityTestResponse;
    })
  );
};

/**
 * API Call to retrieve the source entities of an Assigned Value Test
 */
export const callApiGetSourceEntities = (request: GetSourceEntitiesRequest) => {
  return callApi(webApi.soil.assignedMddTests.getSourceEntities.get(request)).pipe(
    map((response) => {
      return {
        Worksheets: response.Body['AssignedValueMDDTestSourceEntities'].map((w: any) => camelizeObjectKeys(w)),
      };
    })
  );
};

/**
 * API Call to create an assigned value test
 */
export const callApiCreateAssignedValueTest = (worksheetId: Guid, query: CreateAssignedValueTestRequest) => {
  return callApi(
    webApi.soil.assignedMddTests.createAssignedValueTest.post(
      {
        Body: {
          DateAssigned: query.DateAssigned,
          AssignedMaximumDryDensity: query.AssignedMaximumDryDensity,
          AssignedOptimumMoistureContent: query.AssignedOptimumMoistureContent,
          Tests: query.Tests,
        },
      },
      { worksheetId }
    )
  ).pipe(map((response) => response.Body));
};

/**
 * API Call to retrieve results from a batch of selected tests
 */
export const callApiPostSelectedTestResults = (query: SelectedTestResultsQuery) => {
  return callApi(
    webApi.soil.assignedMddTests.getResults.post({ Body: { Tests: query.Tests } as SelectedTestResultsQuery })
  ).pipe(
    map((response) => {
      return {
        messages: response.Body['Messages'],
        results: {
          MeanMaximumDryDensity: response.Body['Results'].MeanMaximumDryDensity,
          GreatestDifferenceFromMeanMdd: response.Body['Results'].GreatestDifferenceFromMeanMdd,
          MeanOptimumMoistureContent: response.Body['Results'].MeanOptimumMoistureContent,
          GreatestDifferenceFromMeanOmc: response.Body['Results'].GreatestDifferenceFromMeanOmc,
        },
      };
    })
  );
};
